module.exports = __webpack_public_path__ + "/bundle/asset/exam-4-3252b7115bdf612850caac84e6def416.png";